/**
 * readinessLenders.js — Sample lender marketplace data for the Readiness
 * experience. All figures are illustrative; P&I is computed from the
 * borrower's actual estimated loan amount.
 */
import { estimatedLoanAmount, fmtMoney } from '../utils/readinessAssessment';
import { monthlyPI } from '../utils/mortgageCalculations';

export const BORROWER_ANON_ID = '#48213';

const FALLBACK_LOAN = 425000;

export function sampleLenderMatches(answers = {}) {
  const loan = estimatedLoanAmount(answers) || FALLBACK_LOAN;
  const pay = (rate) => fmtMoney(monthlyPI(loan, rate, 30)) + '/mo';
  return [
    {
      name: 'Pacific Crest Home Loans', rating: '\u2605 4.8 \u00b7 2,340 reviews',
      rate: '6.250%', apr: '6.410% APR', pay: pay(6.25),
      fees: '$1,200 lender credit', close: '12-day close',
      badge: 'Best rate', status: 'Offer in hand', isOffer: true, cta: 'Review offer',
      take: 'Sharpest pricing in the network right now — and the lender credit trims your closing costs.',
    },
    {
      name: 'Golden Gate Mutual', rating: '\u2605 4.9 \u00b7 1,105 reviews',
      rate: '6.375%', apr: '6.490% APR', pay: pay(6.375),
      fees: 'Origination waived', close: '9-day close',
      badge: 'Fastest close', status: 'Offer in hand', isOffer: true, cta: 'Review offer',
      take: 'The fastest closer I track — ideal if your timeline is tight or you\u2019re trying to win a bidding war.',
    },
    {
      name: 'Sierra Lending Co.', rating: '\u2605 4.6 \u00b7 890 reviews',
      rate: '6.375%', apr: '6.550% APR', pay: pay(6.375),
      fees: '$1,850 total fees', close: '14-day close',
      badge: null, status: 'Reviewing your file', isOffer: false, cta: 'Notify me',
      take: 'Especially strong with self-employed files. I expect their offer within a day.',
    },
    {
      name: 'Bayline Credit Union', rating: '\u2605 4.7 \u00b7 3,020 reviews',
      rate: '6.500%', apr: '6.580% APR', pay: pay(6.5),
      fees: '$950 total fees', close: '18-day close',
      badge: null, status: 'Reviewing your file', isOffer: false, cta: 'Notify me',
      take: 'Member-owned with the lowest fees here — often worth the slightly slower timeline.',
    },
  ];
}
